import { Injectable } from '@angular/core';
import { Observable, interval } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { environment } from 'environments/environment';

//add urls
const urls = {
	v1: 'https://qa.cambridgeone.org/status',
    v2: 'https://v4.icanhazip.com/' //cors , this url allows access content origin *
};


@Injectable()
export class NetwordDetectionService {

    constructor() { }
    networkState = undefined;
    networkObserver: Observable<boolean>;

    async isOnline(recheck=false){
        if(environment.isDesktopApp && (recheck || this.networkState == undefined)){
        
            try {
                if(!navigator.onLine){
                    this.networkState = false;
                }else{
                    this.networkState = await DLS_IPCCallers.GET_NETWORK_STATUS(true);
                }
                return this.networkState;
            } catch (_) {
                this.networkState = false;
                return false;
            }
        }
        else{
            return this.networkState;
        }
    }

    monitorStatus(): Observable<boolean>{
        if(!this.networkObserver){
            this.networkObserver = interval(6000).pipe(switchMap(async()=>await this.isOnline(true)));
        }
        return this.networkObserver;
    }

}